import { Container } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Star, StarOutlineOutlined } from '@material-ui/icons/';
import React, { useState } from 'react';
import ReelsCategoriesScreen from './Categories';
import AddReelsCategoryComponent from './Category_Add';
import AllReelsComponent from './Reels';
import ReelsAddComponent from './Reels_Add';

function TellMeWatch() {

    const [bodyItemText, setBodyItem] = useState('Reels');
    // Returns Body Element According to BodyItemText
    const BodyElement = () => {

        switch (bodyItemText) {
            case 'Reels':
                return <AllReelsComponent />

            case 'Add Reels':
                return <ReelsAddComponent />

            case 'Categories':
                return <ReelsCategoriesScreen />

            case 'Add Category':
                return <AddReelsCategoryComponent />

            default:
                return <h1>Empty - Error!</h1>
        }
    }

    // Changes Body Element
    const DrawerComponent = () => (
        <Box width={240}>
            <List>
                {['Reels', 'Add Reels'].map((text, index) => (
                    <ListItem id={text} button key={text} onClick={() => setBodyItem(text)}>
                        <ListItemIcon>{index % 2 === 0 ? <Star /> : <StarOutlineOutlined />}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List>
                {['Categories', 'Add Category'].map((text, index) => (
                    <ListItem id={text} button key={text} onClick={() => setBodyItem(text)}>
                        <ListItemIcon>{index % 2 === 0 ? <Star /> : <StarOutlineOutlined />}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );


    return (
        <div>
            <Box height={80} />

            <Grid container>

                <DrawerComponent />

                <Container maxWidth="xl" style={{ height: 500 }}>
                    <BodyElement />
                </Container>

            </Grid>

            <Box height={80} />

        </div>
    );

}

export default TellMeWatch;